// extracted by mini-css-extract-plugin
export var productSectionJumbo = "productSectionJumbo-dwJ";